import React, { Fragment, FunctionComponent, useEffect } from 'react';
import styles from './TcmTreatingProvider.Styles';
import { FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup } from '@material-ui/core';
import { EmptyDataLabel } from '../../../../../generic-components/empty-data-label/EmptyDataLabel.Component';
import TcmTreatingProviderEntity from '../../../../../../entities/tcm/TcmTreatingProvider.Entity';
import { TooltipTextField } from '../../../../../generic-components/tooltip-textfield/TooltipTextField.Component';
import InputMask from 'react-input-mask';
import SearchAddressAsync, { AddressValue } from '../../../../../../components/generic-components/search-autocomplete/SearchAddressAsync'
import AddressAutocompleteEntity from '../../../../../../entities/ReferralAddress.Entity';
import StateEntity from '../../../../../../entities/State.Entity';
interface ITcmTreatingProviderProps {
    referralId: number;
    tcmTreatingProvider?: TcmTreatingProviderEntity;
    states: Array<StateEntity>;
    handleTcmTreatingProviderEdit: (provider: TcmTreatingProviderEntity) => void;
}

const parseValue = (value: string): string | boolean => {
    if (value === 'true') return true;
    if (value === 'false') return false;
    return value;
};

export const TcmTreatingProvider: FunctionComponent<ITcmTreatingProviderProps> = (props: ITcmTreatingProviderProps) => {
    const classes = styles();

    const [referralTreatingProviderFullAddress, setReferralTreatingProviderFullAddress] = React.useState("");
    const [providerState, setProviderState] = React.useState<TcmTreatingProviderEntity>(
        props.tcmTreatingProvider || { referralId: props.referralId }
    );

    const MakeFullAddress = (treatingProviderState: TcmTreatingProviderEntity, stateName: string) => {
  // Build the address string while keeping the original spacing/format as close as possible
  const streetSegment = treatingProviderState.addressLine1 ? `${treatingProviderState.addressLine1}, ` : '';
  const addressLine2Segment = treatingProviderState.addressLine2 ? `${treatingProviderState.addressLine2}, ` : '';
  const citySegment = treatingProviderState.cityName ? `${treatingProviderState.cityName}, ` : '';
  const stateSegment = stateName ? `${stateName} ` : '';
  const zipCodeSegment = treatingProviderState.zipCode ? `${treatingProviderState.zipCode}` : '';

  return `${streetSegment}${addressLine2Segment}${citySegment}${stateSegment}${zipCodeSegment}`;
};


    useEffect(() => {
        if (props.tcmTreatingProvider) {
            setProviderState(props.tcmTreatingProvider);
        }
        if(providerState?.stateId)
                {
                    const stateItem = props.states?.find(element => element.stateId==providerState.stateId);
                    
                    setReferralTreatingProviderFullAddress(MakeFullAddress(providerState,stateItem.stateName));
                }
    }, [props.tcmTreatingProvider]);

    const handleTextFieldChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.persist();
        let newProvider: TcmTreatingProviderEntity = { ...providerState };
        if (!newProvider.referralId) {
            newProvider.referralId = props.referralId;
        }

        if (event.target.type === 'checkbox') {
            newProvider[event.target.id || event.target.name] = event.target.checked;
        } else {
            const value = event.target.value;
            newProvider[event.target.id || event.target.name] = parseValue(value);
        }

        setProviderState(newProvider);
        props.handleTcmTreatingProviderEdit(newProvider);
    };

    const passAddress = (address:AddressAutocompleteEntity) => {
            let newTreatingProvider: TcmTreatingProviderEntity = props.tcmTreatingProvider;
            newTreatingProvider["cityName"] = address.city;
            newTreatingProvider["addressLine1"] = `${address.streetNumber? address.streetNumber:''} ${address.streetName}`;
            newTreatingProvider["addressLine2"] = address.address2 ?? "";
            newTreatingProvider["zipCode"] = address.zipCode;        
    
            const stateItem = props.states.find(element => element.stateName==address.stateName);
            newTreatingProvider["stateId"] = stateItem?.stateId;
    
            props.handleTcmTreatingProviderEdit(newTreatingProvider);
            setProviderState(newTreatingProvider);
            setReferralTreatingProviderFullAddress(address.fullAddress);
            
          }
    
          const handleClear = ()=>{
                  
                  let newTreatingProvider: TcmTreatingProviderEntity = props.tcmTreatingProvider
                  newTreatingProvider["cityName"] = undefined
                  newTreatingProvider["addressLine1"] = undefined
                  newTreatingProvider["addressLine2"] = undefined
                  newTreatingProvider["zipCode"] = undefined
                  
                  newTreatingProvider["stateId"] = undefined;
                  
                  setReferralTreatingProviderFullAddress("");
          
                  props.handleTcmTreatingProviderEdit(newTreatingProvider);
                  setProviderState(newTreatingProvider);
              }
    return (
        <Fragment>
            {providerState ? (
                <Grid container spacing={3} className={classes.gridContainer}>
                    <Grid item xs={6}>
                        <TooltipTextField
                            label="First Name"
                            id="firstName"
                            value={providerState?.firstName || ''}
                            onChange={handleTextFieldChange}
                            inputProps={{ maxLength: 50 }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <SearchAddressAsync passAddress={passAddress} states={props.states} />
                        
                    </Grid>

                    <Grid item xs={6}>
                        <TooltipTextField
                            label="Middle Initial"
                            id="middleInitial"
                            value={providerState?.middleInitial || ''}
                            onChange={handleTextFieldChange}
                            inputProps={{ maxLength: 1 }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                    <AddressValue 
                                key="ReferralTreatingProviderSearchAddressResult" 
                                id="ReferralTreatingProviderSearchAddressResult" 
                                address={referralTreatingProviderFullAddress} 
                                handleClear={handleClear} 
                            /> 
                    </Grid>
                    <Grid item xs={6}>
                        <TooltipTextField
                            label="Last Name"
                            id="lastName"
                            value={providerState?.lastName || ''}
                            onChange={handleTextFieldChange}
                            inputProps={{ maxLength: 50 }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                    <InputMask
                            mask="(999)-9999999"
                            value={providerState?.telephoneNumber || ''}
                            onChange={handleTextFieldChange}
                            maskChar=" "
                        >
                            {() => (
                                <TooltipTextField
                                    label="Telephone Number"
                                    id="telephoneNumber"
                                    placeholder="Enter name and phone"
                                />
                            )}
                        </InputMask>
                    </Grid>
                    <Grid item xs={6}>
                        <FormControl component="fieldset">
                            <FormLabel component="legend">In Network</FormLabel>
                            <RadioGroup
                                row
                                aria-label="inNetwork"
                                name="inNetwork"
                                value={providerState?.inNetwork ?? ''}
                                onChange={handleTextFieldChange}
                            >
                                <FormControlLabel value={true} control={<Radio color="primary" />} label="Yes" />
                                <FormControlLabel value={false} control={<Radio color="primary" />} label="No" />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                    <Grid item xs={6}></Grid>
                </Grid>
            ) : (
                <EmptyDataLabel />
            )}
        </Fragment>
    );
};

